import React, { useEffect, useState } from "react";
// import Header from "../../component/header/Header"
import Header from "../../component/header/Header";
import Footer1 from "../../component/footer/Footer1";
import Footer2 from "../../component/footer/Footer2";
import ExclusiveProgram from "../dlfPoints/ExclusiveProgram";
import curve_bg from "../../assets/images/bg-filled-color.png";

import Aside from "../../component/aside/Aside";
import "./Home.scss";
import MyVerticallyCenteredModal2 from "../../component/MyVerticallyCenteredModal2";

const Home = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const id = sessionStorage.getItem("redirectId");
  const submittedId = sessionStorage.getItem("submittedRedirectId");
  useEffect(() => {
    setModalOpen(!!id && id !== submittedId);
  }, [id, submittedId]);
  
  const [activeTab, setActiveTab] = useState("v-pills-home");
  // Function to handle tab change

  return (
    <>
    {isModalOpen && (
      <MyVerticallyCenteredModal2 show={isModalOpen} onHide={()=>setModalOpen(false)} />        
    )}
      <Header activeTab={activeTab} setActiveTab={setActiveTab} />

      <div className="home">
        <div
          className={`home-bg ${activeTab === "v-pills-home" ? "" : "d-none"}`}
        >
          <div
            className={`heading ${
              activeTab === "v-pills-home" ? "" : "d-none"
            }`}
          >
            <h1>Highest Rewarding Loyalty Program</h1>
            <p>Exclusive shopping privileges only for you</p>
          </div>
          <img src={curve_bg} alt="" />
        </div>
        <div
          className={`sidebar ${
            activeTab === "v-pills-home" ? "mt-90 " : "pt-5"
          }`}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-4  col-md-4 desktop_content">
                <Aside activeTab={activeTab} setActiveTab={setActiveTab} />
              </div>
              <div className="col-lg-8 col-md-8">
                <div className="tabs">
                  <div className="tab_content">
                    <div className="tab-content" id="v-pills-tabContent">
                      <div
                        className=""
                        id="v-pills-home"
                        role="tabpanel"
                        aria-labelledby="v-pills-home-tab"
                        tabIndex="0"
                      >
                        <ExclusiveProgram />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footerMobPending"></div>
      {activeTab === "v-pills-home" ? (
        <Footer1 selected="home" />
      ) : (
        <Footer2 selected="home" />
      )}
    </>
  );
};

export default Home;
